// import components
import { styled, Box, BoxProps, alpha } from '@mui/material';

export const StyledToPlanContainerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOver'
})<BoxProps & { isOver: boolean }>(({ theme, isOver }) => ({
  overflow: 'hidden',
  display: 'flex',
  position: 'relative',
  flexShrink: 0,
  flexDirection: 'column',
  boxSizing: 'border-box',
  backgroundColor: isOver
    ? theme.vars.palette.surface.default
    : theme.palette.background.default,
  pointerEvents: 'auto',
  transition: 'border-color 0.2s ease-in-out',
  color: '#6b6b6b',
  margin: 0,
  borderLeft: `1px solid ${theme.palette.divider}`,
  zIndex: 5
}));

export const StyledOverlayBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  height: '100%',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 99999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: theme.typography.h4.fontSize,
  border: `2px dashed ${theme.palette.primary.main}`,
  borderRadius: theme.shape.borderRadius,
  boxSizing: 'border-box',
  margin: theme.spacing(1),
  color: theme.palette.primary.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.1)
}));
